import { createContext, useContext } from 'react'

import { FormType } from 'ui/components'
import { EmailHistoryReportFilterParams, EmailHistoryReportResponse } from '~bank-reports/types/EmailHistoryReport'

type FormData = Pick<EmailHistoryReportFilterParams, 'dateStart' | 'dateEnd'>

type EmailHistoryReportContextValue = {
  data: EmailHistoryReportResponse
  isPending: boolean
  isSuccessFullyLoaded: boolean
  state: EmailHistoryReportFilterParams
  navigate: (searchParams: Partial<EmailHistoryReportFilterParams>) => Promise<void>
  clear: () => void
  formApi: FormType<FormData>
}

export const EmailHistoryReportContext = createContext<EmailHistoryReportContextValue | null>(null)

export const useEmailHistoryReportContext = () => {
  const context = useContext(EmailHistoryReportContext)

  if (!context) {
    throw new Error('useEmailHistoryReportContext must be used within a EmailHistoryReportContext.Provider')
  }

  return context
}
